var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 30,
    viewBox: "0 0 50 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.31 26.251h-4.84a.5.5 0 1 1 0-1h4.35l.28-12.21-7.63-11.79h-6.25v12.42a.5.5 0 0 1-.5.5H8.54v11.08h3.52a.51.51 0 0 1 .5.5.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-12.08a.51.51 0 0 1 .5-.5h25.16V.751a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .42.23L49 12.661a.54.54 0 0 1 .08.28l-.29 12.85a.5.5 0 0 1-.48.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.05 26.251H20.29a.5.5 0 0 1-.5-.5.51.51 0 0 1 .5-.5h14.76a.5.5 0 1 1 0 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M15.89 30.381a4.34 4.34 0 1 1-.02-8.68 4.34 4.34 0 0 1 .02 8.68zm0-7.68a3.34 3.34 0 1 0-.02 6.68 3.34 3.34 0 0 0 .02-6.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M15.89 27.431a1.39 1.39 0 1 1-.02-2.78 1.39 1.39 0 0 1 .02 2.78zm0-1.77a.38.38 0 0 0-.39.38.39.39 0 1 0 .77 0 .38.38 0 0 0-.38-.38zM39.5 30.381a4.34 4.34 0 1 1 4.34-4.34 4.35 4.35 0 0 1-4.34 4.34zm0-7.68a3.34 3.34 0 1 0 3.34 3.34 3.35 3.35 0 0 0-3.34-3.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M39.5 27.431a1.39 1.39 0 1 1 0-2.78 1.39 1.39 0 0 1 0 2.78zm0-1.77a.38.38 0 0 0-.38.38.39.39 0 1 0 .77 0 .38.38 0 0 0-.39-.38zM45.19 13.131h-9a.5.5 0 0 1-.5-.5v-8.38a.51.51 0 0 1 .49-.5l3.86-.09a.54.54 0 0 1 .44.24l5.12 8.47a.52.52 0 0 1 0 .51.52.52 0 0 1-.41.25zm-8.46-1h7.58l-4.5-7.47-3.08.07v7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.47 14.171a.5.5 0 0 1-.5-.5v-9.58H13.41v9.58a.5.5 0 1 1-1 0V3.591a.5.5 0 0 1 .5-.5h17.56a.5.5 0 0 1 .5.5v10.08a.5.5 0 0 1-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M24.6 9.391h-6.1c-.592 0-1.07-.479-1.07-1.07v-1.17c0-.59.478-1.07 1.07-1.07h6.1a1.07 1.07 0 0 1 1 1.07v1.17a1.07 1.07 0 0 1-1 1.07zm-6.1-2.31a.07.07 0 0 0-.07.07v1.17c0 .04.03.07.07.07h6.1a.07.07 0 0 0 0-.07v-1.17a.07.07 0 0 0 0-.07h-6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.78 5.251H1.1a.5.5 0 0 1 0-1h9.68a.5.5 0 1 1 0 1zM8.04 9.391H4.6a.5.5 0 0 1 0-1h3.44a.5.5 0 0 1 0 1zM6.54 12.701H1.1a.5.5 0 0 1-.5-.45.5.5 0 0 1 .5-.5h5.44a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.45z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourier);
export default __webpack_public_path__ + "static/media/courier.39c539f20f97080f22be907881460c8c.svg";
export { ForwardRef as ReactComponent };